import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Container } from "react-bootstrap";
import Header from "../components/buyer/Header1";
import Footer from "../components/buyer/Footer";
import UrgentScrapRequest from "../components/buyer/UrgentScrapRequest";
import CustomAlert from "../components/common/CustomAlert";
import SupportChat from "../components/buyer/SupportChat";
import FloatingActions from "../components/buyer/FloatingActions";

const BuyerLayout = () => {
  const [alert, setAlert] = useState(null); // { message, type }

  const showAlert = (message, type = "success") => {
    setAlert({ message, type });

    // Auto-close after 3 seconds
    setTimeout(() => setAlert(null), 3000);
  };

  return (
    <>
      <div className="d-flex flex-column min-vh-100">
        <Header />
        <Container className="flex-grow-1 my-4">
          <Outlet />
        </Container>
        <Footer />
      </div>

      {/* <UrgentScrapRequest showAlert={showAlert} />
      <SupportChat/> */}
      <FloatingActions />

      {alert && <CustomAlert message={alert.message} type={alert.type} />}
    </>
  );
};

export default BuyerLayout;
